class CartRemoveButton extends HTMLElement {
	constructor() {
		super();

		this.addEventListener("click", (event) => {
			event.preventDefault();

			const targetAriaLabel =
				event.target.getAttribute("aria-label") ||
				event.currentTarget.getAttribute("aria-label");

			const removeItemTitle = targetAriaLabel.split("Remove ")[1];

			const removeItemConfirmContainer = document.getElementById(
				"remove-item-confirm",
			);
			const removeItemConfirmOverlay = document.getElementById(
				"confirm-delete-overlay",
			);
			const removeItemTitleContainer =
				document.getElementById("remove-item-title");
			removeItemTitleContainer.innerText = removeItemTitle;

			const confirmedRemove = document.getElementById("item-remove-yes");
			const confirmedKeep = document.getElementById("item-remove-no");

			removeItemConfirmContainer.classList.remove("hidden");
			removeItemConfirmOverlay.classList.remove("hidden");
			removeItemConfirmOverlay.classList.add("block");

			new Promise((resolve, reject) => {
				function keepListener() {
					reject();
					confirmedKeep.removeEventListener("click", keepListener);
				}
				confirmedKeep.addEventListener("click", keepListener);

				function removeListener() {
					resolve();
					confirmedRemove.removeEventListener("click", removeListener);
				}
				confirmedRemove.addEventListener("click", removeListener);
			})
				.then(() => {
					const cartItems =
						this.closest("cart-items") || this.closest("cart-drawer-items");
					cartItems.updateQuantity(this.dataset.index, 0);
					removeItemConfirmContainer.classList.add("hidden");
					removeItemConfirmOverlay.classList.add("hidden");
				})
				.catch(() => {
					removeItemConfirmContainer.classList.add("hidden");
					removeItemConfirmOverlay.classList.add("hidden");
				});
		});
	}
}

customElements.define("cart-remove-button", CartRemoveButton);

class DiscountApplyButton extends HTMLElement {
	constructor() {
		super();
		this.button = this.querySelector("button");
		this.discountCodeInput = this.querySelector("input[name='discount-code']");
		this.discountErrorContainer = this.querySelector(
			"#discount-application-error-msg",
		);
		this.cart = document.querySelector("cart-drawer");
		this.changeEvent = new Event("change", { bubbles: true });

		if (this.button) {
			this.button.addEventListener("click", this.onButtonClick.bind(this));
		}

		// Add a keydown event listener to the input for detecting the Enter key
		if (this.discountCodeInput) {
			this.discountCodeInput.addEventListener(
				"keydown",
				this.onInputKeydown.bind(this),
			);
		}

		this.querySelectorAll(".remove-discount").forEach((removeButton) => {
			removeButton.addEventListener(
				"click",
				this.onRemoveDiscountClick.bind(this),
			);
		});
	}

	// Handle the Enter key in the input field
	onInputKeydown(event) {
		if (event.key === "Enter") {
			event.preventDefault();
			this.onButtonClick(event);
		}
	}

	async onButtonClick(event) {
		event.preventDefault();
		this.discountErrorContainer.classList.add("hidden");

		const newDiscountCode = this.discountCodeInput
			? this.discountCodeInput.value.trim()
			: "";

		if (!newDiscountCode) {
			this.discountErrorContainer.classList.remove("hidden");
			return;
		}

		this.toggleLoadingEffect(true);

		try {
			const currentDiscountCodes = await this.fetchCurrentDiscountCodes();
			const updatedDiscountCodes =
				currentDiscountCodes[0] === ""
					? [newDiscountCode]
					: [...new Set([...currentDiscountCodes, newDiscountCode])];
			console.log("updatedDiscountCodes =", updatedDiscountCodes);
			const updateResult =
				await this.updateCartDiscountCodes(updatedDiscountCodes);
			console.log("updateResult =", updateResult);
			console.log(
				"updateResult.discountCodeRespose =",
				updateResult.discountCodeResponse.shouldThrowError,
			);
			if (updateResult.discountCodeResponse.shouldThrowError === true) {
				this.discountErrorContainer.classList.remove("hidden");
				return;
			}
			if (window.location.pathname.includes("cart")) {
				await this.refreshCart();
			} else {
				await this.refreshMinicart();
			}
		} catch (error) {
			console.error("Error applying discount code:", error);
		} finally {
			this.toggleLoadingEffect(false);
		}
	}

	async onRemoveDiscountClick(event) {
		event.preventDefault();

		const discountCode = event.currentTarget.dataset.discountCode.toLowerCase();

		if (!discountCode) {
			console.error("No discount code found to remove");
			return;
		}

		this.toggleLoadingEffect(true);

		try {
			const currentDiscountCodes = await this.fetchCurrentDiscountCodes();
			const updatedDiscountCodes = currentDiscountCodes.filter(
				(code) => code.toLowerCase() !== discountCode,
			);

			await this.updateCartDiscountCodes(updatedDiscountCodes);

			if (window.location.pathname.includes("cart")) {
				await this.refreshCart();
			} else {
				await this.refreshMinicart();
			}
		} catch (error) {
			console.error("Error removing discount code:", error);
		} finally {
			this.toggleLoadingEffect(false);
		}
	}

	async updateCartDiscountCodes(discountCodes) {
		const token = await this.fetchCartContents();
		console.log("updateCartDiscountCodes: token =", token);
		if (!token) {
			console.error("Unable to fetch cart token");
			return;
		}
		const encodedDiscountCodes = discountCodes.map((code) =>
			encodeURIComponent(code),
		);

		const encodedToken = encodeURIComponent(token);
		const requestUrl = `${appProxyTarget}?cartToken=${encodedToken}&storePermanentDomain=${Shopify.shop}&discountCodes=${encodedDiscountCodes}`;
		console.log("discount request url", requestUrl);
		const proxyResponse = await fetch(requestUrl);
		const jsonData = await proxyResponse.json();
		console.log("updateCartDiscountcodes: jsonData =", jsonData);
		return jsonData;
	}

	async refreshCart() {
		try {
			const cartPage = await fetch(routes.cart_url);

			if (!cartPage.ok) {
				throw new Error("Network response was not ok");
			}

			const parsedCartPage = await cartPage.text();

			const domParsedCartPage = new DOMParser().parseFromString(
				parsedCartPage,
				"text/html",
			);

			document.querySelector(".shopify-section cart-items").innerHTML =
				domParsedCartPage.querySelector(
					".shopify-section cart-items",
				).innerHTML;
			document.querySelector(
				".cart__footer-wrapper .thermometer-free-shipping-cart",
			).innerHTML = domParsedCartPage.querySelector(
				".cart__footer-wrapper .thermometer-free-shipping-cart",
			).innerHTML;
			document.querySelector(".cart__footer-wrapper .order-summary").innerHTML =
				domParsedCartPage.querySelector(
					".cart__footer-wrapper .order-summary",
				).innerHTML;
			document.querySelector(".cart__footer-wrapper .cart__ctas").innerHTML =
				domParsedCartPage.querySelector(
					".cart__footer-wrapper .cart__ctas",
				).innerHTML;
		} catch (error) {
			console.error("Error refreshing minicart:", error);
		}
	}

	async refreshMinicart() {
		try {
			const response = await fetch("/?sections=cart-drawer,cart-icon-bubble");
			if (!response.ok) {
				throw new Error("Network response was not ok");
			}

			const parsedResponse = await response.json();
			this.cart.renderContents({ sections: parsedResponse });
		} catch (error) {
			console.error("Error refreshing minicart:", error);
		}
	}

	toggleLoadingEffect(isLoading) {
		if (this.button) {
			this.button.disabled = isLoading;
			console.log("first child", this.button.children[0]);
			if (isLoading === true) {
				this.button.children[0].innerHTML = "";
			} else {
				this.button.children[0].innerHTML = "Apply";
			}
			this.button.classList.toggle("loading", isLoading);
		}
	}

	async fetchCartContents() {
		try {
			const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
			if (!cartResponse.ok) {
				throw new Error(`HTTP error! status: ${cartResponse.status}`);
			}
			const cartData = await cartResponse.json();
			return cartData.token;
		} catch (error) {
			console.error("Error fetching cart contents:", error);
			return null;
		}
	}

	async fetchCurrentDiscountCodes() {
		const token = await this.fetchCartContents();
		if (!token) {
			console.error("Unable to fetch cart token");
			return [];
		}

		const encodedToken = encodeURIComponent(token);
		const requestUrl = `${appProxyTarget}?cartToken=${encodedToken}&storePermanentDomain=${Shopify.shop}`;
		console.log("fetch current", requestUrl);
		const proxyResponse = await fetch(requestUrl);
		const jsonData = await proxyResponse.json();
		const discountCodes = jsonData.discountCodesToReturn;
		return discountCodes;
	}
}

customElements.define("discount-apply-button", DiscountApplyButton);

class CartItems extends HTMLElement {
	constructor() {
		super();
		this.lineItemStatusElement =
			document.getElementById("shopping-cart-line-item-status") ||
			document.getElementById("CartDrawer-LineItemStatus");

		const debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, ON_CHANGE_DEBOUNCE_TIMER);

		this.addEventListener("change", debouncedOnChange.bind(this));
	}

	cartUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(
			PUB_SUB_EVENTS.cartUpdate,
			(event) => {
				if (event.source === "cart-items") {
					return;
				}
				this.onCartUpdate();
			},
		);
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
	}

	onChange(event) {
		this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement.getAttribute("name"),
			event.target.parentNode.dataset.productTitle,
		);
	}

	onCartUpdate() {
		fetch(`${routes.cart_url}?section_id=main-cart-items`, {
			headers: {
				"x-hava-alpa":
					"BF26981CA6970831906363B2BEAF1AFB0E469D90454E180ADA12802A012A0E72",
			},
		})
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				const sourceQty = html.querySelector("cart-items");
				this.innerHTML = sourceQty.innerHTML;
			})
			.catch((e) => {
				console.error(e);
			});
	}

	getSectionsToRender() {
		return [
			{
				id: "main-cart-items",
				section: document.getElementById("main-cart-items").dataset.id,
				selector: ".js-contents",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-live-region-text",
				section: "cart-live-region-text",
				selector: ".shopify-section",
			},
			{
				id: "main-cart-footer",
				section: document.getElementById("main-cart-footer").dataset.id,
				selector: ".js-contents",
			},
		];
	}

	updateQuantity(line, quantity, name, productName) {
		this.enableLoading(line);

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${routes.cart_change_url}`, {
			...fetchConfig(),
			...{
				body,
				headers: {
					...fetchConfig().headers,
					"x-hava-alpa":
						"BF26981CA6970831906363B2BEAF1AFB0E469D90454E180ADA12802A012A0E72",
				},
			},
		})
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);

				const cartHelper = customElements.get("cart-helper");
				const currentProgressBar = document.querySelector(
					".pdp-thermometer .progress-bar-content-status",
				);

				if (currentProgressBar) {
					const freeShippingThresholdType = document.querySelector(
						".free-shipping-threshold-type",
					);
					const freeShippingThresholdOrderValue = document.querySelector(
						".free-shipping-threshold-order-value",
					);

					cartHelper.prototype.updateThermometer(
						parsedState.total_price,
						parsedState.item_count,
						currentProgressBar,
						freeShippingThresholdType,
						freeShippingThresholdOrderValue,
					);
				}

				const quantityElement =
					document.getElementById(`Quantity-${line}`) ||
					document.getElementById(`Drawer-quantity-${line}`);
				const items = document.querySelectorAll(".cart-item");

				if (parsedState.errors) {
					quantityElement.value = quantityElement.getAttribute("value");
					let errorMessage = "";
					if (Shopify.locale == "en") {
						errorMessage = `You already have all available ${productName} in your cart`;
					}
					if (Shopify.locale == "es-MX" || Shopify.locale == "es") {
						errorMessage = `Ya tienes todos los ${productName} disponibles en tu carrito`;
					}

					this.updateLiveRegions(line, errorMessage);
					const lineItemError =
						document.getElementById(`Line-item-error-${line}`) ||
						document.getElementById(`CartDrawer-LineItemError-${line}`);
					lineItemError.style.padding = "10px";
					lineItemError.previousElementSibling.classList.remove("loading");
					return;
				}

				const lineItemError =
					document.getElementById(`Line-item-error-${line}`) ||
					document.getElementById(`CartDrawer-LineItemError-${line}`);
				lineItemError.style.padding = "0px";

				this.classList.toggle("is-empty", parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector("cart-drawer");
				const cartFooter = document.getElementById("main-cart-footer");

				if (cartFooter)
					cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
				if (cartDrawerWrapper)
					cartDrawerWrapper.classList.toggle(
						"is-empty",
						parsedState.item_count === 0,
					);

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document
							.getElementById(section.id)
							.querySelector(section.selector) ||
						document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector,
					);
				});
				const updatedValue = parsedState.items[line - 1]
					? parsedState.items[line - 1].quantity
					: undefined;
				let message = "";
				if (
					items.length === parsedState.items.length &&
					updatedValue !== parseInt(quantityElement.value)
				) {
					if (typeof updatedValue === "undefined") {
						message = window.cartStrings.error;
					} else {
						message = window.cartStrings.quantityError.replace(
							"[quantity]",
							updatedValue,
						);
					}
				}
				this.updateLiveRegions(line, message);

				const lineItem =
					document.getElementById(`CartItem-${line}`) ||
					document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper
						? trapFocus(
								cartDrawerWrapper,
								lineItem.querySelector(`[name="${name}"]`),
							)
						: lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper.querySelector(".drawer__inner-empty"),
						cartDrawerWrapper.querySelector("a"),
					);
				} else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper,
						document.querySelector(".cart-item__name"),
					);
				}
				publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
			})
			.catch(() => {
				this.querySelectorAll(".loading-overlay").forEach((overlay) =>
					overlay.classList.add("hidden"),
				);
				const errors =
					document.getElementById("cart-errors") ||
					document.getElementById("CartDrawer-CartErrors");
				errors.textContent = window.cartStrings.error;
			})
			.finally(() => {
				this.disableLoading(line);
			});
	}

	updateLiveRegions(line, message) {
		const lineItemError =
			document.getElementById(`Line-item-error-${line}`) ||
			document.getElementById(`CartDrawer-LineItemError-${line}`);
		if (lineItemError)
			lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

		this.lineItemStatusElement.setAttribute("aria-hidden", true);

		const cartStatus =
			document.getElementById("cart-live-region-text") ||
			document.getElementById("CartDrawer-LiveRegionText");
		cartStatus.setAttribute("aria-hidden", false);

		setTimeout(() => {
			cartStatus.setAttribute("aria-hidden", true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.add("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`,
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`,
		);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
			overlay.classList.remove("hidden"),
		);

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}

	disableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
        if (mainCartItems)	mainCartItems.classList.remove("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`,
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`,
		);

		cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
		cartDrawerItemElements.forEach((overlay) =>
			overlay.classList.add("hidden"),
		);
	}
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"change",
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(
							`${routes.cart_update_url}`,
							...fetchConfig(),
							...{
								body,
								headers: {
									...fetchConfig().headers,
									"x-hava-alpa":
										"BF26981CA6970831906363B2BEAF1AFB0E469D90454E180ADA12802A012A0E72",
								},
							},
						);
					}, ON_CHANGE_DEBOUNCE_TIMER),
				);
			}
		},
	);
}

class CartHelper {
	constructor() {}
	updateThermometer(
		totalPrice,
		quantity,
		currentProgressBar,
		freeShippingThresholdType,
		freeShippingThresholdOrderValue,
	) {
		let percentage = 0;
		let valueToCalc = null;

		if (!freeShippingThresholdOrderValue) return;

		if (
			freeShippingThresholdType &&
			freeShippingThresholdType.value == "by_order_value"
		) {
			valueToCalc = totalPrice;
		}

		if (
			freeShippingThresholdType &&
			freeShippingThresholdType.value == "by_item_count"
		) {
			valueToCalc = quantity;
		}
		percentage = Math.round(
			(valueToCalc / parseInt(freeShippingThresholdOrderValue.value)) * 100,
		);
		currentProgressBar.style.width = `${percentage > 100 ? 100 : percentage}%`;
	}
}

customElements.define("cart-helper", CartHelper);

// turn 'main' element into a flexbox
if (location.pathname == "/cart") {
	let mainContainer = document.getElementById("MainContent");
	mainContainer.classList.add("cart-container");
}

// add event listener to 'show order details', and persist it
function delegatedShowOrdersEventListener(event) {
	const showOrders = document.body.querySelector(".show-order-summary-mobile");
	const orderSummary = document.body.querySelector(".order-summary");

	if (showOrders && orderSummary && event.target === showOrders) {
		orderSummary.classList.toggle("hidden");
	}
}

document.addEventListener("DOMContentLoaded", () => {
	document.body.addEventListener("click", delegatedShowOrdersEventListener);
});

// Change position of 'discount code' depending on screen width
function moveElementBasedOnScreenWidth() {
	const screenWidth = window.innerWidth;
	const breakpoint = 768;
	const promoCodeContainer = document.querySelector(".promo-code-container");
	if (promoCodeContainer) {
		const cartItems = document.querySelector("cart-items");
		const footerContainer = document.querySelector(".footer-container");

		if (screenWidth >= breakpoint) {
			footerContainer.insertBefore(
				promoCodeContainer,
				footerContainer.firstChild,
			);
		} else {
			cartItems.parentNode.insertBefore(
				promoCodeContainer,
				cartItems.nextSibling,
			);
		}
	}
}

moveElementBasedOnScreenWidth();

window.addEventListener("resize", moveElementBasedOnScreenWidth);

// Remove 'help text' from cart on mobile, when user makes cart empty without refresh
document.addEventListener("DOMContentLoaded", function () {
	function toggleDisplayBasedOnPrevSibling() {
		const elements = document.querySelectorAll(".help-text-cart");
		elements.forEach((element) => {
			const prevSibling = element.previousElementSibling;
			if (prevSibling && prevSibling.classList.contains("is-empty")) {
				element.style.display = "none";
			} else {
				element.style.display = "";
			}
		});
	}

	function removeCartItemsWhenEmpty() {
		const cartItemsElement = document.querySelector("cart-items.is-empty");
		const freeShippingWidget = document.querySelector(
			".free-shipping-widget-container",
		);
		const mainCartFooter = document.getElementById("main-cart-footer");
		if (cartItemsElement) {
			cartItemsElement.parentNode.style.display = "none";
			mainCartFooter.parentNode.style.margin = "auto";
			mainCartFooter.parentNode.style.width = "auto";
			if (freeShippingWidget) {
				freeShippingWidget.style.opacity = "0";
			}
		}
	}

	toggleDisplayBasedOnPrevSibling();
	removeCartItemsWhenEmpty();

	const observer = new MutationObserver((mutationsList, observer) => {
		for (const mutation of mutationsList) {
			if (mutation.type === "childList") {
				toggleDisplayBasedOnPrevSibling();
				removeCartItemsWhenEmpty();
			}
		}
	});

	const cartTargetNode = document.body;

	const cartConfig = { attributes: false, childList: true, subtree: true };

	observer.observe(cartTargetNode, cartConfig);
});
